import { Swiper, SwiperSlide } from 'swiper/react';
import { useMediaQuery } from 'react-responsive';
import 'swiper/css';
import Graph1Img from '../../../../../../../images/graphs/rf.svg';
import LastBlock from './last-block/last-block';
import styles from './gallery-tables.module.css';

function GalleryTablesProduct() {
  const isMobile = useMediaQuery({ query: '(max-width: 760px)' });

  return (
    <div className={styles.section}>
      <div className={styles.containerWrapper}>
        <div className={styles.navigationBox}>
          <div className={styles.chartsTitle}>Наша доходность</div>
        </div>

        <div className={styles.slider}>
            <Swiper
              slidesPerView={isMobile ? 1.3 : 2.2}
              spaceBetween={isMobile ? 8: 20}
              className={styles.swiper}
              >
              <SwiperSlide className={styles.swiperSlide}>
                <img src={Graph1Img} className={styles.img} alt={'Российский портфель'}/>
              </SwiperSlide>
              <SwiperSlide>
                <div className={styles.img}>
                  <LastBlock subName={'Unity Россия'} subHref={'PriceSection'} />
                </div>
              </SwiperSlide>
            </Swiper>
        </div>
      </div>
    </div>
  );
}

export default GalleryTablesProduct;
